import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { newSidebarEnabled } from './newSidebarEnabled'

export const usePageDescription = (): ComputedRef<string | undefined> => {
  const route = useRoute()
  // eslint-disable-next-line @typescript-eslint/unbound-method -- false positive
  const { t, te } = useI18n()
  const { isEnabled: isNewSidebarEnabled } = newSidebarEnabled()

  return computed(() => {
    for (let i = route.matched.length - 1; i > 0; i--) {
      const match = route.matched[i]

      if (match?.meta?.title) {
        // temporary logic for feature flag evaluation
        // after the feature flag is fully deployed, we can change this back to
        // const key = `core.pages.${match.meta.title}.description`

        const title = match.meta.title
        // Handle billing routes with feature flag
        if (match.meta.billingRoute === true) {
          const titleKey = isNewSidebarEnabled.value
            ? `billing.${title}`
            : 'billing'
          const key = `core.pages.${titleKey}.description`
          return te(key) ? t(key) : undefined
        }
        const key = `core.pages.${title}.description`

        return te(key) ? t(key) : undefined
      }
    }

    return undefined
  })
}
